import React, { useContext, useEffect, useRef, useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { MdDeliveryDining } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useApolloClient, useMutation, gql } from "@apollo/client";

import NestPassImg from "../../assets/NestPass.png";
import { LocationContext } from "../../context/Location";
import { QueryStoreNestPass } from "../../apollo/queries";
import { NestPassPurchase } from "../../apollo/mutations";
import UseCookie from "../../utils/cookies/useCookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const queryStoreNestPass = gql`${QueryStoreNestPass}`;
const purchaseNestPass = gql`${NestPassPurchase}`;


const Loader = () => (
  <div className="flex justify-center items-center h-40">
    <div className="loader ease-linear rounded-full border-2 border-t-8 border-gray-200 h-10 w-10" />
  </div>
);

export function NestPass({ banner, openPremuimBanner,colors, isNestPassPage }) {

  const { location } = useContext(LocationContext);
  const { t } = useTranslation();

  const client = useApolloClient();
  const navigateScreenTo = useNavigate();
  const [nestPassData, setNestPassData] = useState(null);
  const [loginInfo, setLoginInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [placingOrder, setPlacingOrder] = useState(false);
    const { setCustomCookie, getCustomCookie, removeCustomCookie, clearAllCookies } = UseCookie();
  const [PurchaseNestPass] = useMutation(purchaseNestPass);

  const modalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = await getCustomCookie("loginInfo");
        setLoginInfo(user);
        const { data } = await client.query({
          query: queryStoreNestPass,
          variables: {
            longitude: location?.longitude || "77.59104670126453",
            latitude: location?.latitude || "13.04269368886535",
          },
          fetchPolicy: "no-cache",
        });
        setNestPassData(data?.queryStoreNestPass);
      } catch (err) {
        console.error("NestPass | fetch error", err);
        navigateScreenTo('/')
        toast.error("Please login!",{position: "top-right",autoClose: 3000,})
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, location]);

  const confirmOrder = async () => {
     try{
      let data = await PurchaseNestPass({})
      //console.log("🚀 ~ confirmOrder ~ data:", data)
      const params = new URLSearchParams({
            passId : data?.data?.generateNestPassHashCode
        });
        window.history.pushState({ },'',`/`);
        // window.location.href  = `${process.env.REACT_APP_SERVER_URL}/phonepe/nestpasspayment?${params.toString()}`
        window.location.href  = `${process.env.REACT_APP_SERVER_URL}/phonepe/nestpasspayment?${params.toString()}`
     }
     catch(error){
        //console.log("🚀 ~ confirmOrder ~ error:", error)

     }
  };

  const alertPurchaseNestPass = () => {
    // if (!nestPassData) return;
    // if (window.confirm(`Confirm purchase NestPass for ₹${nestPassData.regularPurchasePrice} (valid for ${nestPassData.expiryInMonths} ${nestPassData.expiryInMonths > 1 ? "months" : "month"})?`)) {
    // }
    confirmOrder();
  };

    const closeModal = () => {
        //console.log("🚀 ~ closeModal ~ closeModal:")
        if(isNestPassPage){
          navigateScreenTo('/')
        }
        openPremuimBanner(false)
        document.removeEventListener("mousedown", handleClickOutside);
    };


    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closeModal();
        }
    };


  return (
    <div className="relative z-50" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-modalBackGround transition-opacity" onClick={closeModal} />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div ref={modalRef} className="relative bg-NestPassBg transform overflow-hidden rounded-lg shadow-xl transition-all w-full sm:max-w-lg">
            <IoClose
                onClick={()=>closeModal()}
                className={` absolute z-20 right-3 top-3 sm:right-3 sm:top-3 md:right-4 md:top-4 lg:right-5 lg:top-5 h-4 sm:h-4 md:h-4 lg:h-6 w-4 sm:w-4 md:w-4 lg:w-6 cursor-pointer text-appThemeColorVeryDark transition duration-200 transform active:scale-50 cursor-pointer`}
                aria-hidden="true"
            />
            <div className="max-h-[80vh] overflow-y-auto p-4 space-y-4">
              {isLoading || placingOrder ? (
                <Loader />
              ) : (
                <>
                  <div className="relative w-full h-56 overflow-hidden rounded-md">
                    <img src={NestPassImg} alt="NestPass" className="object-contain w-full h-full" />
                  </div>
                  <div className="flex flex-col items-center gap-4">
                    <div className="text-center space-y-1">
                      <h2 className="font-bold text-xl" style={{ color: colors?.bottomTopBtn }}>{t("yourGateWayTo")}</h2>
                      <h2 className="font-bold text-xl" style={{ color: colors?.bottomTopBtn }}>{t("bigSavings")}</h2>
                    </div>
                    <p className="text-center text-sm" style={{ color: colors?.bottomTopBtn }}>{t("nestPassMsg")}</p>
                    <div className="flex-1 flex flex-col items-center w-full">
                        <div className="w-full rounded-t-lg border shadow px-4 py-3 bg-white" style={{ borderColor: colors?.bottomTopBtnBorder }}>
                            <p className="text-center font-bold text-2xl" style={{ color: colors?.bottomTopBtn }}>₹{nestPassData?.regularPurchasePrice}</p>
                            <p className="text-center text-xs" style={{ color: colors?.bottomTopBtn }}>For {nestPassData.expiryInMonths} Months</p>
                        </div>
                        <div className="w-full flex items-center justify-center gap-2 rounded-b-lg py-1 shadow bg-appThemeColorVeryDark" style={{  }}>
                            <MdDeliveryDining className="text-base" style={{ color: colors?.white }} />
                            <span className="font-bold text-xs" style={{ color: colors?.white }}>Free Delivery</span>
                            <span className="font-bold text-xs" style={{ color: colors?.white }}>|</span>
                            <span className="font-bold text-xs" style={{ color: colors?.white }}>Offers on products</span>
                        </div>
                    </div>
                    <div className="w-full rounded-lg border shadow px-4 py-3 bg-white" style={{ borderColor: colors?.bottomTopBtnBorder }}>
                      <p className="text-center text-sm" style={{ color: colors?.bottomTopBtn }}>{nestPassData.message}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {!isLoading && <button onClick={alertPurchaseNestPass} className="w-full py-3 text-base font-bold flex text-white items-center justify-center bg-appThemeColorVeryDark" disabled={placingOrder || isLoading}>
              {t("Proceed")}
            </button>}
          </div>
        </div>
      </div>
    </div>
  );
}
